import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  FormControlLabel,
  FormGroup,
  Checkbox,
  FormLabel,
  Paper,
  Typography,
  IconButton,
  Input,
  InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PrestadorApi from '../../../api/PrestadorApi';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import FastForward from '@material-ui/icons/FastForward';
import FastRewind from '@material-ui/icons/FastRewind';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import SearchIcon from '@material-ui/icons/Search';
import { parse, isBefore } from 'date-fns';
const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  },
  selectTabela: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(2),
    width: 200,
  },  
  formControlSelectPrestadores: {
    marginTop: theme.spacing(1),
    margin: theme.spacing(1),
    marginLeft: theme.spacing(1),
    minWidth: 50,
    display: 'inline'
  },  
  formLabelPrestadores: {
    display: 'inline',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2)
  },  
  paperPrestadores: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    margin: theme.spacing(1),
    marginTop: theme.spacing(1),
    overflow: 'auto',
    maxHeight: '35vh',
    height: '35vh',
    width: 730,
  },  
  divButtons: {
    marginTop: theme.spacing(5),
    display: 'inline-grid',
  },  
  formControlPrestadoresSelecionados: {
    marginTop: theme.spacing(1),
    margin: theme.spacing(1),
    minWidth: 50,
    display: 'inline'
  },  
  fontSizeMenor: {
    fontSize: 13
  },
  paddingZero: {
    padding: '0.2px',
  },
  controlFiltro: {
    marginLeft: theme.spacing(3),
    width: theme.spacing(60)
  },
  textFieldData: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 232,
    marginRight: theme.spacing(2),
  },  
});
class FormDialogAdicionarPrestador extends React.Component {
  prestadorApi = new PrestadorApi();
  state = {
    fetching: false,

    prestadoresSelected: [],
    prestadoresSelectedComNome: [],
    prestadoresVinculados: this.props.prestadoresVinculados,
    
    prestadores: [],
    prestadoresOriginal: [],
    prestadoresFiltrados: [],
    prestadoresNaoVinculadosSelected: [],
    prestadoresNaoVinculadosSelectedComNome: [],

    filtroPrestador: '',
    errorMessageDataInicio: '',
    errorMessageDataFim: '',
    dtaInicio: null,
    dtaFim: null
  }
  componentDidMount = async () => {    
    this.setState({fetching: true});
    let prestadores = await this.prestadorApi.consultarNomesPrestadoresComCnpj('S');
    this.setState({prestadores: prestadores, prestadoresFiltrados: prestadores, prestadoresOriginal: prestadores, fetching: false});

    let prestadoresNaoVinculadosSelected = this.state.prestadoresNaoVinculadosSelected;
    let prestadoresNaoVinculadosSelectedComNome = this.state.prestadoresNaoVinculadosSelectedComNome;
    
    for (var i = 0; i < this.state.prestadoresVinculados.length; i++) {
      let codPrestador = this.state.prestadoresVinculados[i][2];
      let desPrestador = this.state.prestadoresVinculados[i][0];
      let codItemTaxaPrestador = this.state.prestadoresVinculados[i][1];
      let indPodeExcluir = this.state.prestadoresVinculados[i][8];
      let indAlterou = this.state.prestadoresVinculados[i][9];
      let dtaInicio = parse(this.state.prestadoresVinculados[i][3]);
      let dtaFim = parse(this.state.prestadoresVinculados[i][4]);
      prestadoresNaoVinculadosSelected.push(Number(codPrestador));
      prestadoresNaoVinculadosSelectedComNome.push({id: Number(codPrestador), nome: desPrestador, codItemTaxaPrestador: codItemTaxaPrestador, indPodeExcluir: indPodeExcluir, indAlterou: indAlterou, dtaInicio: dtaInicio, dtaFim: dtaFim});
    }
    this.setState({ prestadoresNaoVinculadosSelected: prestadoresNaoVinculadosSelected,
      prestadoresNaoVinculadosSelectedComNome: prestadoresNaoVinculadosSelectedComNome });
    this.vincularPrestadores();

    }
  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    this.setState({fetching: true});
    let prestadoresVinculados = [];
    let brancoAcoes = '';
    for (var i = 0; i < this.state.prestadoresSelectedComNome.length; i++) {
      let prestadorVinculado = {
        codItemTaxaPrestador: this.state.prestadoresSelectedComNome[i].codItemTaxaPrestador === undefined ? 0 : this.state.prestadoresSelectedComNome[i].codItemTaxaPrestador,
        codPrestador: this.state.prestadoresSelectedComNome[i].id,
        dtaInicio: this.state.prestadoresSelectedComNome[i].codItemTaxaPrestador === undefined ? parse(this.state.dtaInicio) : this.state.prestadoresSelectedComNome[i].dtaInicio,
        dtaFim: this.state.prestadoresSelectedComNome[i].codItemTaxaPrestador === undefined ? (this.state.dtaFim === null ? null : parse(this.state.dtaFim)) : this.state.prestadoresSelectedComNome[i].dtaFim,
        codItemTaxa: 0,
        indAtivo: 'S',
        nomPrestador: this.state.prestadoresSelectedComNome[i].nome,
        indPodeExcluir: this.state.prestadoresSelectedComNome[i].indPodeExcluir === undefined ? 'N' : this.state.prestadoresSelectedComNome[i].indPodeExcluir,
        indAlterou: this.state.prestadoresSelectedComNome[i].indAlterou === undefined ? 'N' : this.state.prestadoresSelectedComNome[i].indAlterou,
      }
      prestadoresVinculados.push(prestadorVinculado);
    }
    let prestadoresVinculadosExtract = [];
    prestadoresVinculados.map(res => {
      const { codItemTaxaPrestador, codPrestador, dtaInicio, dtaFim, codItemTaxa, indAtivo, nomPrestador, indPodeExcluir, indAlterou } = res;      
      prestadoresVinculadosExtract.push(Object.values({ nomPrestador, codItemTaxaPrestador, codPrestador, dtaInicio, dtaFim, codItemTaxa, indAtivo, brancoAcoes, indPodeExcluir, indAlterou }));
      });      
    this.props.handleSave(prestadoresVinculadosExtract);
  }  
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeFilterPrestador = name => (event) => {
    const inputValue = event.target.value.replace(/[^a-zA-Zà-úÀ-Ú0-9\s]/g, '').toUpperCase();    
    this.setState({ [name]: inputValue, boxPrestadoresSelected: [] });
  }  

  handleChangeCheckBoxPrestadoresNaoVinculados = event => {
    let prestadoresNaoVinculadosSelected = this.state.prestadoresNaoVinculadosSelected;
    let prestadoresNaoVinculadosSelectedComNome = this.state.prestadoresNaoVinculadosSelectedComNome;
    if (event.target.checked) {
      prestadoresNaoVinculadosSelected.push(Number(event.target.id));
      prestadoresNaoVinculadosSelectedComNome.push({id: Number(event.target.id), nome: event.target.name});
    } else {
      var index = prestadoresNaoVinculadosSelected.indexOf(Number(event.target.id));
      prestadoresNaoVinculadosSelected.splice(index, 1);
      prestadoresNaoVinculadosSelectedComNome.splice(index, 1);
    }
    this.setState({ prestadoresNaoVinculadosSelected: prestadoresNaoVinculadosSelected,
      prestadoresNaoVinculadosSelectedComNome: prestadoresNaoVinculadosSelectedComNome });
  }

  handleChangeCheckBoxPrestadoresVinculados = event => {
    let prestadoresSelected = this.state.prestadoresSelected;

    if (event.target.checked) {
      prestadoresSelected.push(Number(event.target.id));
    } else {
      var index = prestadoresSelected.indexOf(Number(event.target.id));
      prestadoresSelected.splice(index, 1);
    }
    this.setState({ prestadoresSelected: prestadoresSelected.sort() });
  }
  vincularTodos = () => {
    this.setState({
    prestadores: [], 
    prestadoresFiltrados: [], 
    filtroPrestador: '',
    prestadoresSelectedComNome: this.state.prestadoresOriginal,
    prestadoresNaoVinculadosSelected: [],
    prestadoresNaoVinculadosSelectedComNome: [] });   
  }
  desvincularTodos = () => {
    this.setState({
      prestadores: this.state.prestadoresOriginal, 
      prestadoresFiltrados: this.state.prestadoresOriginal, 
      filtroPrestador: '',
      prestadoresSelected: [],
      prestadoresSelectedComNome: [], 
      prestadoresNaoVinculadosSelected: [], 
      prestadoresNaoVinculadosSelectedComNome: []}
      );
  }
  vincularPrestadores = () => {
    let prestadores = this.state.prestadoresFiltrados;
    let prestadoresSelectedComNome = this.state.prestadoresSelectedComNome;
    for (var i = 0; i < this.state.prestadoresNaoVinculadosSelected.length; i++) {
      for (var j = 0; j < this.state.prestadoresFiltrados.length; j++) {
        if (this.state.prestadoresNaoVinculadosSelected[i] === this.state.prestadoresFiltrados[j].id) {
          prestadores.splice(j, 1);
        }
      }
    }
    this.setState({ prestadoresSelected: [],
      prestadoresSelectedComNome: prestadoresSelectedComNome.concat(this.state.prestadoresNaoVinculadosSelectedComNome),
      prestadores: prestadores,
      prestadoresNaoVinculadosSelected: [],
      prestadoresNaoVinculadosSelectedComNome: [] });
  }  

  desvincularPrestadores = () => {
    let prestadores = Array.from(this.state.prestadoresFiltrados);
    let prestadoresSelected = Array.from(this.state.prestadoresSelected);
    prestadoresSelected = prestadoresSelected.sort();
    let prestadoresSelectedComNome = Array.from(this.state.prestadoresSelectedComNome);
    let lenPrestadoresSelected = prestadoresSelected.length;
    let lenPrestadoresSelectedComNome = prestadoresSelectedComNome.length;
    let i = 0;
    let j = 0;
    for (i = 0; i < lenPrestadoresSelectedComNome; i++) {
      for (j = 0; j < lenPrestadoresSelected; j++) {
        if (prestadoresSelectedComNome[i].id === prestadoresSelected[j]) {
          prestadores.push({id: Number(this.state.prestadoresSelectedComNome[i].id), nome: this.state.prestadoresSelectedComNome[i].nome});
        }
      }
    }
    i = 0;
    j = 0;
    for (i = 0; i < lenPrestadoresSelected; i++) {
      j = prestadoresSelectedComNome.findIndex(x => x.id === this.state.prestadoresSelected[i]);
      prestadoresSelectedComNome.splice(j, 1);
    }
    prestadores = prestadores.sort(this.dynamicSort('id'));
    this.setState({ prestadoresSelected: [],
      prestadoresSelectedComNome: prestadoresSelectedComNome,
      prestadores: prestadores.sort(this.dynamicSort('id')),
      prestadoresNaoVinculadosSelected: [],
      prestadoresNaoVinculadosSelectedComNome: [] });
  }

  dynamicSort (property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    };
  }
  handleBlurDataInicio = () => {
    if (this.state.dtaInicio === null ||
      this.state.dtaInicio === undefined ||
      this.state.dtaInicio === '') {
      this.setState({errorMessageDataInicio: 'Este campo é obrigatório'});
    } else {
      if (this.state.dtaFim !== null && isBefore(parse(this.state.dtaFim), parse(this.state.dtaInicio))){
        this.setState({errorMessageDataInicio: 'Data início maior que data fim'});
      } else {
        this.setState({errorMessageDataInicio: ''});
      }
    }
  }
  handleBlurDataFim = () => {    
    if (this.state.dtaFim === 'Invalid Date') {      
      this.setState({errorMessageDataFim: 'Data Inválida'});
    } else {
      if (this.state.dtaFim !== null && isBefore(parse(this.state.dtaFim), parse(this.state.dtaInicio))){        
        this.setState({errorMessageDataFim: 'Data fim menor que data início'});
      } else {
        this.setState({errorMessageDataFim: ''});
      }
    }
  }
  render () {
    const { open, titulo, classes } = this.props;
    const { fetching, prestadoresSelected, prestadoresSelectedComNome,
      prestadoresVinculados, prestadores,
      prestadoresNaoVinculadosSelected,
      prestadoresNaoVinculadosSelectedComNome } = this.state;

    const regexFiltroPrestador = new RegExp(this.state.filtroPrestador);
    const prestadoresFiltrados = prestadores
    .filter(prestador => {
      return (
        regexFiltroPrestador.test(prestador.nome.toUpperCase()));
      });

    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xl'
          scroll='body'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
          </DialogTitle>
          <DialogContent>
            <FormControl className={classes.controlFiltro}>
              <Input
                fullWidth
                type='search'
                placeholder={'Filtro'}
                value={this.state.filtroPrestador}
                onChange={this.handleChangeFilterPrestador('filtroPrestador')}
                startAdornment={<InputAdornment position='start'><SearchIcon /></InputAdornment>}
              />
            </FormControl>

            {fetching ? <LinearProgressBlockScreen />
            : <Paper style={{display: 'inline-flex'}}>
              <FormControl className={classes.formControlSelectPrestadores}>
                <FormLabel component='legend' className={classes.formLabelPrestadores}>Prestadores Não Vinculados:</FormLabel>
                <Paper className={classes.paperPrestadores}>
                  <FormGroup>
                    {prestadoresFiltrados.length > 0
                      ? prestadoresFiltrados.map((prestador, idx) => (
                        <FormGroup key={idx}>
                          <FormControlLabel   
                            control={
                              <Checkbox
                                checked={prestadoresNaoVinculadosSelected.includes(prestador.id)}
                                className={classes.paddingZero}
                                key={idx}
                                name={prestador.nome}
                                id={prestador.id.toString()}
                                onChange={this.handleChangeCheckBoxPrestadoresNaoVinculados}
                                value={prestador.nome} />
                            }
                            label={
                              <Typography className={classes.fontSizeMenor}>
                                {prestador.nome}
                              </Typography>                              
                            }
                          />
                        </FormGroup>
                      ))
                      : <Typography>Prestadores Não Encontrados</Typography>}
                  </FormGroup>
                </Paper>
              </FormControl>
              <div className={classes.divButtons}>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={prestadoresFiltrados.length === 0}
                  title='Vincular Todos'
                  onClick={this.vincularTodos}
                  >
                  <FastForward />
                </IconButton>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={prestadoresNaoVinculadosSelected.length === 0}
                  title='Escolher Prestadores'
                  onClick={this.vincularPrestadores}
                  >
                  <ChevronRight />
                </IconButton>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={prestadoresSelected.length === 0}
                  title='Retirar Prestadores'
                  onClick={this.desvincularPrestadores}
                  >
                  <ChevronLeft />
                </IconButton>
                <IconButton
                  size='small'
                  color='primary'
                  disabled={prestadoresSelectedComNome.length === 0}
                  title='Retirar Todos'
                  onClick={this.desvincularTodos}
                  >
                  <FastRewind />
                </IconButton>
              </div>
              <FormControl className={classes.formControlPrestadoresSelecionados}>
                <FormLabel component='legend' className={classes.formLabelPrestadores}>Prestadores Selecionados:</FormLabel>
                <Paper className={classes.paperPrestadores}>
                  <FormGroup>
                    {prestadoresSelectedComNome.length > 0
                      ? prestadoresSelectedComNome.map((prestador, idx) => (
                        <FormGroup key={idx}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={prestadoresSelected.includes(prestador.id)}
                                className={classes.paddingZero}
                                key={idx}
                                name={prestador.nome}
                                id={prestador.id.toString()}
                                onChange={this.handleChangeCheckBoxPrestadoresVinculados}
                                value={prestador.nome} />
                            }
                            label={
                              <Typography className={classes.fontSizeMenor}>
                                {prestador.nome}
                              </Typography>                              
                            }
                          />
                        </FormGroup>
                      ))
                      : <Typography>Taxa sem Prestadores Vinculados</Typography>}
                  </FormGroup>
                </Paper>
              </FormControl>
            </Paper>}
            <Paper>
            <FormControl>
                <TextField
                  id='date'
                  error={this.state.errorMessageDataInicio !== ''}
                  label={this.state.errorMessageDataInicio !== '' ? this.state.errorMessageDataInicio : '*Data Inicial'}
                  type='date'
                  value={this.state.dtaInicio}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurDataFim}
                  inputProps={{
                    name: 'dtaInicio',
                  }}
                  className={classes.textFieldData}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
              <FormControl>
                <TextField
                  id='date'
                  error={this.state.errorMessageDataFim !== ''}
                  label={this.state.errorMessageDataFim !== '' ? this.state.errorMessageDataFim : 'Data Fim'}
                  type='date'
                  value={this.state.dtaFim}
                  onChange={this.handleChange}
                  onBlur={this.handleBlurDataFim}
                  inputProps={{
                    name: 'dtaFim',
                  }}
                  className={classes.textFieldData}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.prestadoresSelectedComNome.length === 0 || this.state.dtaInicio === null || this.state.dtaInicio === '' || this.state.dtaInicio === undefined
              || this.state.errorMessageDataInicio !== '' || this.state.errorMessageDataFim !== ''}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogAdicionarPrestador);
